<template>
  <div>
    <h3 class="mt-3">Resources / Capacity</h3>

    <div class="row mt-5">
        <div class="scheduleTypeHolder col-sm-10 d-flex align-items-center mb-3">
            <button type="button" class="btn tertiary" :class="{'selected': getSelectedEvent.availabilityType == availabilityType.value}" v-for="availabilityType in availabilityTypes" @click="setAvailabiltyType(availabilityType)">{{availabilityType.label}}</button>
        </div>



        <div class="col-sm-10" v-if="getSelectedEvent.availabilityType == 2">
            <div class="d-flex align-items-start">
                <!-- <checkbox class="d-inline" :disabled="disabled"></checkbox> -->
                <span>Share availability with other products</span>
            </div>
            <div class="mt-2 mb-3 fs-small dark">
              <div class="d-flex">
                <radio v-model="getSelectedEvent.shareType" :value="0" class="d-inline" :disabled="getSelectedEvent.isPrivateEvent == true || getSelectedEvent.shareType == 2">
                    NO<br>
                </radio >
              </div>
              <div class="d-flex mt-2">
                <radio v-model="getSelectedEvent.shareType" :value="1" class="d-inline" :disabled="getSelectedEvent.isPrivateEvent == true || getSelectedEvent.shareType == 2">
                    YES. Products that use the same resource at the same time will share availability. You can set max.seats per product.<br>
                </radio >
              </div>
              <!-- <div class="d-flex mt-2">
                <radio v-model="getSelectedEvent.shareType" :value="2" class="d-inline" :disabled="getSelectedEvent.isPrivateEvent == true || getSelectedEvent.shareType == 2">
                    Virtual Roster - If a product is using the same resource at the same time, the first activity to be booked will turn the other activities unavailable to book.
                </radio >
              </div> -->
            </div>
        </div>

        <div v-if="getSelectedEvent.availabilityType == 0" class="col-sm-10 d-flex align-items-center mb-3">
            <label class="full">
                Total Capacity
                <input type="text" class="bg-lighter mt-1" size="2" v-model="getSelectedEvent.maximumLotation">
            </label>
            <!-- <checkbox name="allotment" class="ml-3 mt-3" v-model="hasAllotments">Set Allotment</checkbox> -->
        </div>

      <div class="col-sm-10">
            <div class="row">
                <div class="col-sm-6">
                    <label class="full">
                        Resources for this event
                    </label>
                </div>
                <div class="col-sm-4">
                    <label>Capacity limit</label>
                </div>
            </div>

        <div class="row align-items-center mt-2" v-for="resource, index in getSelectedEvent.eventResources">

            <div class="col-sm-6">
                <v-select class="mr-2" :options="tweakedResources" v-model="getSelectedEvent.eventResources[index]" @input="resouceSelected(getSelectedEvent.eventResources[index])" label="name"></v-select>
            </div>

            <div class="col-sm-4 text-right d-flex align-items-center">
                <span v-if="getSelectedEvent.availabilityType == 2">
                    <input type="text" style="width: 55px;" class="mr-1" v-model="resource.maxSeats">
                    /
                </span>
                <span>{{resource.availability}}</span>
            </div>

            <div class="col-sm-2">
                <i class="ico ico-delete largest dark pointer" @click="removeResource(index)"></i>
            </div>

            <div class="col-sm-12" v-if="resource.isAvailable !== undefined && !resource.isAvailable">
                <span class="color-6 fs-small font-weight-600">Warning! This resource is already in use at this time</span>
            </div>
        </div>

        <div class="mt-5">
          <span @click="addResource">
            <span class="ico-add color-1 mr-1 rounded-circle border-color-1 p-1 pointer"></span>
            <label class="pointer">Add New</label>
          </span>
        </div>

        <div class="color-6 my-2" v-if="validations.getSelectedEvent.resources.$invalid">
            If availbility is "Limited by resources" then you need at least one resource.
        </div>

      </div>
    </div>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    export default {
        created: function(){
            console.log('getSelectedEvent', this.getSelectedEvent);
            this.initResources();
            this.resourcesAvailabilty = this.getAvailableResources();
        },
        props: {
            validations: {
                type: Object
            }
        },
        data: function() {
            return {
                resourcesAvailabilty: [],
                tweakedResources: [],
                availabilityTypes: [
                    {
                        label: 'Unlimited',
                        value: 1,
                    },
                    {
                        label: 'Fixed limit',
                        value: 0,
                    },
                    {
                        label: 'Limited by resources',
                        value: 2,
                    },
                ]
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'getResources',
                'account'
            ]),
            resourcesFromAPI: function(){
                return this.getResources
            }
        },
        methods:{
            ...mapActions([
                'initResources'
            ]),
            addResource: function(){
                if(this.getResources && this.getResources.length > 0){
                    this.getSelectedEvent.eventResources.push(this.getResources[0]);
                } else {
                    this.getSelectedEvent.eventResources.push({
                        "name": " "
                    });
                }
            },
            removeResource: function(index){
                this.getSelectedEvent.eventResources.splice(index, 1);
            },
            async getAvailableResources(){
                try {
                    let response = await axios.get('/api/calendar/GetResourcesAvailabilityStatus',
                        { params: {
                            supplierId: this.account.supplierId,
                            dateFrom: this.getSelectedEvent.start,
                            dateTo: this.getSelectedEvent.end
                        }
                    });

                    if (response && response.status === 200) {
                        let resourcesAvailabilty = response.data;
                        this.resourcesAvailabilty = resourcesAvailabilty;

                        //this populate tweakedResources with a array of objects that is the apiResource with the added key "isAvailable"
                        this.tweakedResources = [];
                        for (let avalResource of resourcesAvailabilty) {
                            let tempObj = avalResource.resource;
                            tempObj.isAvailable = avalResource.isAvailable;
                            this.tweakedResources.push(tempObj)
                        }


                        return response.data;
                    }

                } catch (error) {
                    //this.$toasted.error(error.response.data.message);
                }
            },
            setAvailabiltyType: function(availabilityType) {
                this.$set(this.getSelectedEvent, 'availabilityType', availabilityType.value)
                console.log('here');
                if(availabilityType.value == 2 && this.getSelectedEvent.eventResources.length == 0){
                    this.addResource()
                    if(this.getSelectedEvent.shareType == null){
                        this.getSelectedEvent.shareType = 0
                    }
                }
                // this.getSelectedEvent.availabilityType = availabilityType.value
                // this.setAvailabiltyOnGroups()
            },
            resouceSelected: function(selectedResource) {
                if(selectedResource.maxSeats < 0){
                    selectedResource.maxSeats = selectedResource.availability
                }
            }
        },
        components: {
          vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables.scss';
.scheduleTypeHolder{
    button{
        line-height: normal;
        height: 80px;
        width: 160px;
        margin-right: 0.5rem;

        &.selected{
            border-color: $color-1;
            border-width: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// areaResources.vue?62cb3411